"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WeekHeader = function WeekHeader(_ref) {
  var date = _ref.date,
      dayFormat = _ref.dayFormat,
      localizer = _ref.localizer,
      activeDate = _ref.activeDate;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _utils.datesEqual)(date, activeDate) ? 'rbc-today' : ''
  }, (0, _utils.localizeFormat)(localizer, date, localizer.formats.weekdayFormat), ' ', /*#__PURE__*/_react.default.createElement("span", null, (0, _utils.localizeFormat)(localizer, date, dayFormat)));
};

WeekHeader.propTypes = {
  date: _propTypes.default.string.isRequired,
  dayFormat: _propTypes.default.string.isRequired,
  activeDate: _propTypes.default.string.isRequired,
  localizer: _propTypes.default.shape({
    format: _propTypes.default.func,
    formats: _propTypes.default.shape({
      weekdayFormat: _propTypes.default.string
    })
  }).isRequired
};
var _default = WeekHeader;
exports.default = _default;